import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { modals } from '@modals';
import * as models from '@models';

import CardLoadable from './CardLoadable.vue';

/**
 * `CardOrqaController` component properties.
 */
export interface Props {
  orqaProduct: models.Product | null;
  loading?: boolean;
}


declare module 'vue/types/vue' {
  export interface Vue {
    CardOrqaController: ComponentWithProps<Props>;
  }
}

const CARD_BODY_TEXT =
  'The Orqa FPV controller is now available for purchase through Zephyr!\n\nFunctionalities:\n- Built-in rechargeable battery\n- USB-C for connectivity and charging\n\nLook & Feel:\n- Gamepad style ergonomics\n- Perfect fit for small or big hands\n- Robust and solid feel\n- Programmable buttons\n\nDedicated FPV.Ctrl Mobile App to Manage your settings. Search "FPV.Ctrl" on iOS or Android app stores.\n\n';

const __default__ = { name: 'CardOrqaController' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    orqaProduct: null,
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { orqaProduct: models.Product | null, loading: boolean };



const title = computed(() => props?.orqaProduct?.name ?? []);

function openOrqaModal() {
  if (!props?.orqaProduct?.id) return;

  return void modals.shop.productDetails({ productId: props?.orqaProduct?.id });
}

return { __sfc: true,CARD_BODY_TEXT, props, title, openOrqaModal, CardLoadable }
}

})